export const createFilterDescription = filters => {
  if (filters) {
    const filterStringArray: string[] = []
    if (filters.assignedTo && filters.assignedTo.length > 0) {
      filterStringArray.push('Assigned To')
    }
    if (filters.deliveryAddress && filters.deliveryAddress.length > 0) {
      filterStringArray.push('Delivery Address')
    }
    if (filters.deliveryId && filters.deliveryId.length > 0) {
      filterStringArray.push('Delivery ID')
    }
    if (filters.knownSupplierName && filters.knownSupplierName.length > 0) {
      filterStringArray.push('Supplier Company')
    }
    if (filters.tradeContractor && filters.tradeContractor.length > 0) {
      filterStringArray.push('Trade Contractor')
    }

    if (filterStringArray.length > 0) {
      return filterStringArray.join(', ')
    }
  }

  return ''
}
